// Accessible "Explore" mega-dropdown (and any [data-wfc-dropdown]).
// Click to toggle, Escape + outside-click to close, basic ARIA. Matches the live
// header's Explore menu (Venues / Events / Destinations / Nightlife stories).

export function initDropdown(root = document) {
  const dropdowns = root.querySelectorAll("[data-wfc-dropdown]:not([data-dd-bound])");

  dropdowns.forEach((dd) => {
    dd.setAttribute("data-dd-bound", "");
    const btn  = dd.querySelector("[data-dd-toggle]");
    const menu = dd.querySelector("[data-dd-menu]");
    if (!btn || !menu) return;

    const close = () => {
      dd.classList.remove("is-open");
      btn.setAttribute("aria-expanded", "false");
    };
    const open = () => {
      dd.classList.add("is-open");
      btn.setAttribute("aria-expanded", "true");
    };

    btn.setAttribute("aria-haspopup", "true");
    btn.setAttribute("aria-expanded", "false");

    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      dd.classList.contains("is-open") ? close() : open();
    });
    document.addEventListener("click", (e) => { if (!dd.contains(e.target)) close(); });
    dd.addEventListener("keydown", (e) => { if (e.key === "Escape") { close(); btn.focus(); } });
  });
}
